export const CREATE_SHORTEN = 'create_shorten'
export const GET_ORIGINAL = 'get_original'
